import { FaqService } from "@vahak/core/dist/_services/faq.service";
import { useDefaultTopLayout } from "components/layout/layout-methods";

export const getGrowNetworkPageLayout = useDefaultTopLayout;

export const getGrowNetworkStaticProps = async () => {
    const { faqs } = await FaqService.getFaqsByCateg({
        categSlug: "grow-networks"
    });

    return { faqs };
};
